import { getUserAuthDataFromLocalStorage } from '../utils';

export default function authWrapper(url) {
  const accessToken = getUserAuthDataFromLocalStorage().accessToken;
  const localUrl = url.replace(/(.*)\?access_token=.*/, '$1');
  return `${localUrl}?access_token=${accessToken}`;
}



// WEBPACK FOOTER //
// ./src/utils/authWrapper.js